var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { getStorageItem, setStorageItem } from './storageManager';
/**
 * Gets zip code from various sources in priority order:
 * 1. window.app_data.zipCode
 * 2. localStorage locationCoords
 * 3. Fresh location request
 * @returns the zip code or an empty string if not available
 */
var getZipCode = function () { return __awaiter(void 0, void 0, void 0, function () {
    var zipCode, locationCoords, requestLocation, locationObj, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                zipCode = ((_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.zipCode) || '';
                if (zipCode)
                    return [2 /*return*/, zipCode];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, , 7]);
                locationCoords = getStorageItem('locationCoords') || {};
                if (!(locationCoords === null || locationCoords === void 0 ? void 0 : locationCoords.postalCode)) return [3 /*break*/, 2];
                zipCode = locationCoords.postalCode;
                return [3 /*break*/, 5];
            case 2: return [4 /*yield*/, import('../components/Viewplans/helper')];
            case 3:
                requestLocation = (_b.sent()).requestLocation;
                return [4 /*yield*/, requestLocation()];
            case 4:
                locationObj = _b.sent();
                zipCode = (locationObj === null || locationObj === void 0 ? void 0 : locationObj.postalCode) || '';
                _b.label = 5;
            case 5:
                // Cache in window.app_data if available
                if (zipCode && window.app_data) {
                    window.app_data.zipCode = zipCode;
                }
                return [2 /*return*/, zipCode];
            case 6:
                error_1 = _b.sent();
                console.error('Error getting zip code:', error_1);
                return [2 /*return*/, ''];
            case 7: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetches teams data for a given zip code
 * @param zipCode the zip code to fetch teams for
 * @returns an array of teams or an empty array if there's an error or no teams are available
 */
var fetchTeamsData = function (zipCode) { return __awaiter(void 0, void 0, void 0, function () {
    var site, apiBaseUrl, apiBaseCachedUrl, response, error_2;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                if (!zipCode) {
                    return [2 /*return*/, []];
                }
                _k.label = 1;
            case 1:
                _k.trys.push([1, 3, , 4]);
                site = ((_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.siteInternalName) || '';
                apiBaseUrl = (_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsMain) === null || _d === void 0 ? void 0 : _d.apiConfig) === null || _e === void 0 ? void 0 : _e.apiBaseUrl;
                apiBaseCachedUrl = (_h = (_g = (_f = window === null || window === void 0 ? void 0 : window.app_data) === null || _f === void 0 ? void 0 : _f.appcmsMain) === null || _g === void 0 ? void 0 : _g.apiConfig) === null || _h === void 0 ? void 0 : _h.apiBaseCachedUrl;
                return [4 /*yield*/, axios.get("".concat(apiBaseCachedUrl || apiBaseUrl, "/v4/content/personalization/choices"), {
                        params: {
                            site: site,
                            contentType: 'team',
                            zipcode: zipCode
                        },
                        headers: {
                            'x-api-key': (window === null || window === void 0 ? void 0 : window.xApiKey) || ''
                        }
                    })];
            case 2:
                response = _k.sent();
                return [2 /*return*/, ((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.teams) || []];
            case 3:
                error_2 = _k.sent();
                console.error('Error fetching teams data:', error_2);
                return [2 /*return*/, []];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Retrieves user preferred team IDs from sessionStorage
 * @returns {Array<string>} Array of team IDs or empty array
 */
var getUserPreferredTeamIds = function () {
    var _a, _b, _c, _d;
    try {
        var authStore = getStorageItem('AuthenticationStore');
        var userTeams = (_d = (_c = (_b = (_a = authStore === null || authStore === void 0 ? void 0 : authStore.user) === null || _a === void 0 ? void 0 : _a.profiles) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.contentPersonalization) === null || _d === void 0 ? void 0 : _d.teams;
        if (Array.isArray(userTeams) && userTeams.length > 0) {
            return userTeams.map(function (team) { return team === null || team === void 0 ? void 0 : team.id; }).filter(function (id) { return id != null; });
        }
        return [];
    }
    catch (error) {
        console.error('Error parsing user preferred teams from sessionStorage');
        return [];
    }
};
/**
 * Retrieves zipcode-location based team IDs from sessionStorage
 * @returns {Array} Array of team IDs or empty array
 */
var getLocationBasedTeamIds = function () {
    try {
        var teamsData = getStorageItem('teamsData') || [];
        if (Array.isArray(teamsData) && teamsData.length > 0) {
            var teamIds = teamsData.map(function (team) { return team === null || team === void 0 ? void 0 : team.id; }).filter(function (id) { return id != null; });
            return teamIds;
        }
        return [];
    }
    catch (error) {
        console.error('Error parsing teamsData from sessionStorage');
        return [];
    }
};
/**
 * Retrieves team IDs with priority: user preferred > location-based > empty array
 * @returns {Array<string>} Array of team IDs or empty array
 */
var getPersonalizedTeamIds = function () {
    var userPreferredTeamIds = getUserPreferredTeamIds();
    if ((userPreferredTeamIds === null || userPreferredTeamIds === void 0 ? void 0 : userPreferredTeamIds.length) > 0)
        return userPreferredTeamIds;
    var locationBasedTeamIds = getLocationBasedTeamIds();
    if ((locationBasedTeamIds === null || locationBasedTeamIds === void 0 ? void 0 : locationBasedTeamIds.length) > 0)
        return locationBasedTeamIds;
    return [];
};
/**
 * Checks teams availability based on user's zipcode and caches the result
 * @returns true if teams are available, false otherwise
 */
var checkTeamsAvailability = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userPreferredTeam, zipCode, teams, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                userPreferredTeam = getUserPreferredTeamIds();
                if (Array.isArray(userPreferredTeam) && userPreferredTeam.length > 0)
                    return [2 /*return*/, true];
                return [4 /*yield*/, getZipCode()];
            case 1:
                zipCode = _a.sent();
                return [4 /*yield*/, fetchTeamsData(zipCode)];
            case 2:
                teams = _a.sent();
                // Cache teams data
                setStorageItem('teamsData', teams);
                return [2 /*return*/, teams.length > 0];
            case 3:
                error_3 = _a.sent();
                console.error('Error checking teams availability:', error_3);
                setStorageItem('teamsData', []);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
export { getZipCode, fetchTeamsData, getLocationBasedTeamIds, getUserPreferredTeamIds, getPersonalizedTeamIds, checkTeamsAvailability, };
